import _ from 'lodash';
import mediaQuery from 'css-mediaquery';

function createMatchMedia(width: number) {
  return (query: string): MediaQueryList => ({
    matches: mediaQuery.match(query, { width }) as boolean,
    media: '',
    addListener: () => _.noop,
    removeListener: () => _.noop,
    onchange: () => _.noop,
    addEventListener: () => _.noop,
    removeEventListener: () => _.noop,
    dispatchEvent: _.constant(true),
  });
}

// example: mockMatchMedia(window.innerWidth);
export function mockMatchMedia(width: number) {
  window.matchMedia = createMatchMedia(width);
}

/**
 * Replaces the global IntersectionObserver with a synchronous stub that immediately reports
 * every observed target as intersecting. Useful for tests that render real (unmocked)
 * lazy-rendering components (e.g. CarouselV2 / ProductCarousel v2), which otherwise never
 * render their children under jsdom's default no-op IntersectionObserver stub.
 */
export function mockIntersectionObserverImmediate(): void {
  function ImmediateIntersectionObserver(callback: IntersectionObserverCallback): IntersectionObserver {
    const instance = {
      root: null,
      rootMargin: '',
      thresholds: [],
      observe: (target: Element): void => {
        callback([({ isIntersecting: true, target } as unknown) as IntersectionObserverEntry], instance);
      },
      unobserve: (): void => undefined,
      disconnect: (): void => undefined,
      takeRecords: (): IntersectionObserverEntry[] => [],
    };

    return instance;
  }

  ((global as unknown) as {
    IntersectionObserver: unknown;
  }).IntersectionObserver = ImmediateIntersectionObserver;
}
